import LegalEntityFunctions from "./LegalEntityFunctions.jsx";

export default {
  validatePersonalCode(personalCode, legalEntityId) {
    let isPersonalCodeValid = !!personalCode;
    let errorMessage = "";
    
    if (!isPersonalCodeValid) {
      errorMessage = "smart_id_add_wizard_personal_code_required_error";
    }
    else if (!LegalEntityFunctions.getPersonalCodeLengths()[legalEntityId].includes(personalCode.length)) {
      errorMessage = "smart_id_add_wizard_personal_code_length_error";
      isPersonalCodeValid = false;
    }
    
    return {
      isValid: isPersonalCodeValid,
      errorMessage: errorMessage
    };
  },

  isPersonalCodeValid(personalCode, legalEntityId) {
    return this.validatePersonalCode(personalCode, legalEntityId).isValid;
  },

  getPersonalCodeError(personalCode, legalEntityId) {
    const result = this.validatePersonalCode(personalCode, legalEntityId);
    return result.isValid ? null : result.errorMessage;
  }
}; 